import { durationPickerType } from "redux/Types";

export const clearanceFormType = {
    // 'PROMO': "cftypePromo",
    // 'SPORT': "cftypeSports",
    // 'PROGRAMMING': "cftypeProgramming",
    'PROMO': "1",
    'SPORT': "2",
    'PROGRAMMING': "3",
    'NEWS': "4",
};

export const programmeTypes = {
    'SERIES': 'series',
    'ONEOFF': 'oneoff',
    'EPISODE': 'episode',
};

export const programmeAndFormType = {
    'PROMO': `${clearanceFormType.PROMO}-${programmeTypes.ONEOFF}`,
    'SPORT': `${clearanceFormType.SPORT}-${programmeTypes.ONEOFF}`,
    'PROGRAMMING_ONEOFF': `${clearanceFormType.PROGRAMMING}-${programmeTypes.ONEOFF}`,
    'PROGRAMMING_EPISODES': `${clearanceFormType.PROGRAMMING}-${programmeTypes.EPISODE}`,
    'NEWS': `${clearanceFormType.NEWS}-${programmeTypes.ONEOFF}`,
    'PROGRAMMING_SERIES': `${clearanceFormType.PROGRAMMING}-${programmeTypes.SERIES}`,
    "SPORT_SERIES": `${clearanceFormType.SPORT}-${programmeTypes.SERIES}`,
    "SPORT_EPISODES": `${clearanceFormType.SPORT}-${programmeTypes.EPISODE}`,
}


export const programmeAndFormTypeList = [
    {
        label: "Sports",
        value: programmeAndFormType.SPORT,
        iconProp: {
            imgSrc: `/clearance-images/sky-sports.png`,
            altText: "Sports Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Promotion",
        value: programmeAndFormType.PROMO,
        iconProp: {
            imgSrc: `/clearance-images/sky-promo.png`,
            altText: "Promotion Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Programme - Oneoff",
        value: programmeAndFormType.PROGRAMMING_ONEOFF,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "Programme Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Programme - Episode",
        value: programmeAndFormType.PROGRAMMING_EPISODES,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "Programme Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "News",
        value: programmeAndFormType.NEWS,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "News Logo",
            backgroundColor: "#575757"
        },
    },
    // {
    //     label: "Programme - Series",
    //     value: programmeAndFormType.PROGRAMMING_SERIES,
    //     iconProp: {
    //         imgSrc: `/clearance-images/sky-programme.png`,
    //         altText: "Programme Logo",
    //         backgroundColor: "#575757"
    //     },
    // },
];
export const programmeAndFormTypeTableList = [
    {
        label: "Sports",
        value: programmeAndFormType.SPORT,
        iconProp: {
            imgSrc: `/clearance-images/sky-sports.png`,
            altText: "Sports Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Sports - Series (Migrated)",
        value: programmeAndFormType.SPORT_SERIES,
        iconProp: {
            imgSrc: `/clearance-images/sky-sports.png`,
            altText: "Sports Logo",
            backgroundColor: "#575757",
        },
    },
    {
        label: "Sports - Episodes (Migrated)",
        value: programmeAndFormType.SPORT_EPISODES,
        iconProp: {
            imgSrc: `/clearance-images/sky-sports.png`,
            altText: "Sports Logo",
            backgroundColor: "#575757",
        },
    },
    {
        label: "Promotion",
        value: programmeAndFormType.PROMO,
        iconProp: {
            imgSrc: `/clearance-images/sky-promo.png`,
            altText: "Promotion Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Programme - Oneoff",
        value: programmeAndFormType.PROGRAMMING_ONEOFF,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "Programme Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Programme - Episode",
        value: programmeAndFormType.PROGRAMMING_EPISODES,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "Programme Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "News",
        value: programmeAndFormType.NEWS,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "News Logo",
            backgroundColor: "#575757"
        },
    },
    {
        label: "Programme - Series",
        value: programmeAndFormType.PROGRAMMING_SERIES,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "Programme Logo",
            backgroundColor: "#575757"
        },
    },
];

export const clearanceFormTypeList = [
    {
        label: "Sports",
        value: clearanceFormType.SPORT,
        iconProp: {
            imgSrc: `/clearance-images/sky-sports.png`,
            altText: "Sports Logo",
            // backgroundColor: "#D08140"
            backgroundColor: "#575757"
        },
    },
    {
        label: "Promotion",
        value: clearanceFormType.PROMO,
        iconProp: {
            imgSrc: `/clearance-images/sky-promo.png`,
            altText: "Promotion Logo",
            // backgroundColor: "#5863aa"
            backgroundColor: "#575757"
        },
    },
    {
        label: "Programme",
        value: clearanceFormType.PROGRAMMING,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "Programme Logo",
            // backgroundColor: "#388e73"
            backgroundColor: "#575757"
        },
    },
    {
        label: "News",
        value: clearanceFormType.NEWS,
        iconProp: {
            imgSrc: `/clearance-images/sky-programme.png`,
            altText: "News Logo",
            // backgroundColor: "#388e73"
            backgroundColor: "#575757"
        },
    },
];

export const standardProgrammeType = {
    Commercial: "CM",
    Ident: "ID",
    Live: "NW",
    Normal: "ON",
    Normal: "SR",
    Promo: "TR",
}

export const standardProgrammeTypes = [
    {
        "value": standardProgrammeType.Commercial,
        "label": "Commercial"
    },
    {
        "value": standardProgrammeType.Ident,
        "label": "Ident"
    },
    {
        "value": standardProgrammeType.Live,
        "label": "Live"
    },
    {
        "value": standardProgrammeType.Normal,
        "label": "Normal"
    },
    {
        "value": standardProgrammeType.Normal,
        "label": "Normal(SR)"
    },
    {
        "value": standardProgrammeType.Promo,
        "label": "Promo"
    }
]


export const standardProductionSourceType = {
    acquired: "A",
    coProduction: "C",
    inHouse: "H",
    commissioned: "I",
    commercial: "P",
    repackaged: "R",
    unknown: "U",
}

export const standardMusicOriginType = {
    StudioFootage: "A",
    SpecCommSatvPublOnly: "B",
    Commercial: "C",
    ConcertFootage: "D",
    LivePerformance: "E",
    FilmClip: "F",
    ProductionLibraryNonMechanical: "H",
    EPK: "K",
    OriginalMovieSoundtrack: "M",
    TVSoundtrack: "N",
    SpecCommSatvPublOther: "O",
    ProductionMusic: "P",
    TitleTrack: "R",
    SpecCommNonSatvPubl: "S",
    SATVLibrary: "T",
    Unknown: "U",
    MusicVideo: "V",
    ProgrammeClip: "W",
    Actuality: "X",
    MusicVideoVisualOnly: "Z"
}

export const validOriginForCatNoChange = [standardMusicOriginType.Commercial, standardMusicOriginType.ProductionMusic, standardMusicOriginType.TVSoundtrack, standardMusicOriginType.FilmClip, standardMusicOriginType.ProductionLibraryNonMechanical]

export const standardProductionSourceTypes = [
    {
        "value": standardProductionSourceType.acquired,
        "label": "Acquired"
    },
    {
        "value": standardProductionSourceType.coProduction,
        "label": "Co Production"
    },
    {
        "value": standardProductionSourceType.inHouse,
        "label": "In-House"
    },
    {
        "value": standardProductionSourceType.commissioned,
        "label": "Commissioned"
    },
    {
        "value": standardProductionSourceType.commercial,
        "label": "Commercial"
    },
    {
        "value": standardProductionSourceType.repackaged,
        "label": "Repackaged"
    },
    {
        "value": standardProductionSourceType.unknown,
        "label": "Unknown"
    }
]

export const columnFields = {
    PROMO: ["name", "promotionId", "prodNumber", "cfProgrammeAndFormType", "updatedAt"],
    COMMISSIONED: ["seriesTitle", "episodeTitle", "episodeNumber", "contractNumber", "cfProgrammeAndFormType", "updatedAt"],
    INHOUSE: ["name", "prodNumber", "cfProgrammeAndFormType", "updatedAt"],
    DEFAULT: ["name", "prodNumber", "cfProgrammeAndFormType", "updatedAt"],
}
export const columnFilterFields = {
    PROMO: [
        { field: "name", label: "Promotion Title" },
        { field: "promotionId", label: "Promotion ID" },
        { field: "prodNumber", label: "Version ID (Prod No)" },
        // { field: "cfProgrammeAndFormType", label: "CL Form Type" },
        // { field: "name", label: "Promotion Title" },

    ],
    COMMISSIONED: [
        { field: "seriesTitle", label: "Series Name" },
        { field: "episodeTitle", label: "Episode Name" },
        { field: "episodeNumber", label: "Episode Number" },
        { field: "contractNumber", label: "Contract Number" },
        { field: "cfProgrammeAndFormType", label: "CL Form Type" },
        // { field: "name", label: "Promotion Title" },

    ],
    DEFAULT: [
        { field: "name", label: "Form Title" },
        { field: "prodNumber", label: "Production Number (MAM ID)" },
        { field: "cfProgrammeAndFormType", label: "CL Form Type" },
    ],
}
export const societyIndicator = {
    MCPS: { noLabel: "MCPS No", yesLabel: "MCPS Yes" },
    PRS: { noLabel: "PRS No", yesLabel: "PRS Yes" },
    PPL: { noLabel: "PPL No", yesLabel: "PRS Yes" },
}
export const societyIndicatorParamId = {
    MCPS: "35",
    PPL: "31",
}
export const trackUsageParamId = {
    SPORT: "187",
    DEFAULT: "135",
}

export const clearanceFormTrackOrgStatusExt = {
    APPROVED: 108, //cleared
    LICENSED: 102,
    MIGRATED_LICENSED: 11,
    RERER_TO_LICENSING: 105,
};

export const formatTwoDigits = (number) => {
    if (!isNaN(number)) number = number.toString();
    return number < 10 && number.length === 1 ? '0' + number : number.toString();
}

export const societyIndicatorMcpsTypes = {
    mcps: 1,
    nonMcps: 2,
    mcpsPA: 3
}

export const societyIndicatorMcpsTypeList = [
    {
        label: "MCPS",
        value: societyIndicatorMcpsTypes.mcps
    },
    {
        label: "Non MCPS",
        value: societyIndicatorMcpsTypes.nonMcps
    },
    {
        label: "MCPS P.A.",
        value: societyIndicatorMcpsTypes.mcpsPA
    },
]

export const societyIndicatorPplTypes = {
    ppl: 1,
    nonPpl: 2,
    pplNonSync: 3,
}

export const societyIndicatorPplTypeList = [
    {
        label: "PPL",
        value: societyIndicatorPplTypes.ppl
    },
    {
        label: "Non PPL",
        value: societyIndicatorPplTypes.nonPpl
    },
    {
        label: "PPL Non-Sync",
        value: societyIndicatorPplTypes.pplNonSync,
    },
]

export const standardSocietyIndMapping = {
    none: 0,
    nonPpl: 1,
    nonMcps: 2,
    nonMcpsNonPpl: 3,
    mcpsPa: 4,
    mcpsPaNonPpl: 5,
    mcpsPaPPLNonSync: 6,
    nonMcpsPPLNonSync: 7,
    PPLNonSync: 8,
}

export const standardSocietyIndMappingList = [
    {
        label: "",
        value: standardSocietyIndMapping.none
    },
    {
        label: "Non PPL",
        value: standardSocietyIndMapping.nonPpl
    },
    {
        label: "Non MCPS",
        value: standardSocietyIndMapping.nonMcps
    },
    {
        label: "Non MCPS/Non PPL",
        value: standardSocietyIndMapping.nonMcpsNonPpl
    },
    {
        label: "MCPS PA",
        value: standardSocietyIndMapping.mcpsPa
    },
    {
        label: "MCPS PA/Non PPL",
        value: standardSocietyIndMapping.mcpsPaNonPpl
    },
    {
        label: "MCPS PA/PPL Non-Sync",
        value: standardSocietyIndMapping.mcpsPaPPLNonSync
    },
    {
        label: "Non-MCPS/PPL Non-Sync",
        value: standardSocietyIndMapping.nonMcpsPPLNonSync
    },
    {
        label: "PPL Non-Sync",
        value: standardSocietyIndMapping.PPLNonSync
    },
]


export const getDurationValue = (dType = durationPickerType.HHMMSS, value) => {
    const seconds = value;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    switch (dType) {
        case durationPickerType.SS:
            return `${remainingSeconds}`;
        case durationPickerType.MMSS:
            let m = Math.floor(seconds / 60);
            let s = seconds % 60;
            return `00:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        // return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
        case durationPickerType.HHMM:
            // return `${hours}:${minutes}`;
            return `${seconds / 60}`;
        case durationPickerType.HHMMSS:
        default:
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }
}

export const getTimeToSeconds = (time) => {
    // Split the time string into an array of [hours, minutes, seconds]
    const [hours, minutes, seconds] = time.split(':').map(Number);

    // Calculate total seconds
    const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;

    return totalSeconds;
}

export const getUsageLabel = (value, parameters, paramId) => {
    let displayVal = value;
    if (paramId && parameters.length > 0) {
        switch (paramId) {
            case trackUsageParamId.SPORT:
                let i = parameters.findIndex(e => e.id == paramId);
                if (i != -1) {
                    displayVal = parameters[i].options.find(item => item.id == value)?.label || value;
                }

                break;
            default:
                let ii = parameters.findIndex(e => e.id == paramId);
                if (ii != -1) {
                    displayVal = parameters[ii].options.find(item => item.id == value)?.label || value;
                }
        }
    }
    return displayVal
}

const trackMusicOrigins = {
    originall: "originall",
    library_non_mechanical: "library_non_mechanical",
    library: "library",
    satv_library: "satv_library",
    spec_comm_satv_publ_only: "spec_comm_satv_publ_only",
    spec_comm_satv_publ_other: "spec_comm_satv_publ_other",
    video: "video",
    tv_soundtrack: "tv_soundtrack",
    film_soundtrack: "film_soundtrack",
    commercial: "commercial",
    live: "live",
    commissioned: "commissioned",
    unknown: "unknown",
    sound_fx: "sound_fx",
    actuality: "actuality",
    concert_footage: "concert_footage",
    film_clip: "film_clip",
    programme_clip: "programme_clip",
    studio_footage: "studio_footage",
};

export const getSocietyIndicator = (track) => {
    let societyInd = standardSocietyIndMapping.none;

    if (track?.clearancestatus == clearanceFormTrackOrgStatusExt.LICENSED || track?.clearancestatus == clearanceFormTrackOrgStatusExt.MIGRATED_LICENSED || (track?.origin == trackMusicOrigins.commercial && track?.origin == trackMusicOrigins.library)) {

        if (track.societyIndicatorMcps == societyIndicatorMcpsTypes.nonMcps && track.societyIndicatorPpl == societyIndicatorPplTypes.nonPpl) {
            societyInd = standardSocietyIndMapping.nonMcpsNonPpl;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.nonPpl && track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcpsPA) {
            societyInd = standardSocietyIndMapping.mcpsPaNonPpl;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.ppl && track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcps) {
            societyInd = standardSocietyIndMapping.none;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.ppl && track.societyIndicatorMcps == societyIndicatorMcpsTypes.nonMcps) {
            societyInd = standardSocietyIndMapping.nonMcps;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.ppl && track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcpsPA) {
            societyInd = standardSocietyIndMapping.mcpsPa;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.nonPpl && track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcps) {
            societyInd = standardSocietyIndMapping.nonPpl;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.pplNonSync && track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcpsPA) {
            societyInd = standardSocietyIndMapping.mcpsPaPPLNonSync;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.pplNonSync && track.societyIndicatorMcps == societyIndicatorMcpsTypes.nonMcps) {
            societyInd = standardSocietyIndMapping.nonMcpsPPLNonSync;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.pplNonSync && track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcps) {
            societyInd = standardSocietyIndMapping.PPLNonSync;
        }
        else if (track.societyIndicatorPpl == societyIndicatorPplTypes.nonPpl) {
            societyInd = standardSocietyIndMapping.nonPpl;
        }
        else if (track.societyIndicatorMcps == societyIndicatorMcpsTypes.mcpsPA) {
            societyInd = standardSocietyIndMapping.mcpsPa;
        }
        else if (track.societyIndicatorMcps == societyIndicatorMcpsTypes.nonMcps) {
            societyInd = standardSocietyIndMapping.nonMcps;
        }
        else {
            societyInd = standardSocietyIndMapping.none;
        }
    }
    return societyInd
}

export const cueSheetAutoSaveInterval = 30000; // 30 seconds

export const mltombfiltertypes = {
    DEPARTMENT: "department",
    INPUTGROUP: "inputgroup",
}

export const MBTrackUsageMapping = [
    {
        "value": "Background",
        "label": "Background",
        "MLMapping": "B",
    },
    {
        "value": "OpeningTitles_PreTitles",
        "label": "Featured",
        "MLMapping": "F",
    },
    {
        "value": "BreakBumpers",
        "label": "Featured",
        "MLMapping": "F",
    },
    {
        "value": "ClosingCredits",
        "label": "Featured",
        "MLMapping": "F",
    },
    {
        "value": "MusicVideo",
        "label": "Featured",
        "MLMapping": "F",
    },
    {
        "value": "LivePerformance",
        "label": "Featured",
        "MLMapping": "F",
    },
    
]

export const multiDepartmentMappingMltoMB = [
    {
        mlDepartmentIds: [
            62, //Athletics
            63, //Badminton
            64, //Boxing
            66, //Cycling
            67, //Darts
            68, //Dogs
            69, //Equestrian
            70, //Fishing
            106, //Fit In 5
            107, //GAA
            78, //Gymnastics
            79, //Motorsports
            110, //NBA
            80, //NFL
            108, //Netball
            93, //Ping Pong
            81, //Poker
            82, //Pool
            83, //Rugby League
            16, //Rugby Union
            84, //Sailing
            109, //Sky Sports - Other
            105, //Sky Sports Mix
            102, //Sky Sports Originals
            111, //Sky Sports Racing
            85, //Snooker
            86, //Soccer AM
            87, //Soccer Saturday
            88, //Speedway
            90, //Tennis
            91, //WWE
        ],
        mbDepartmentId: 555,
        filterType: mltombfiltertypes.DEPARTMENT
    },
    {
        mlDepartmentIds: [
            72, //Football - Champions League
            73, //Football - Football League
            74, //Football - Other
            75, //Football - Premier League
            71, //Football - Spanish
           
        ], 
        mbDepartmentId: 92,
        filterType: mltombfiltertypes.DEPARTMENT
    },
    {
        mlDepartmentIds: [
            94, //Sky Studio Sound input group
           
        ], 
        mbDepartmentId: 562,
        filterType: mltombfiltertypes.INPUTGROUP
    },
    {
        mlDepartmentIds: [
            68, //Comedy Central input group
           
        ], 
        mbDepartmentId: 99,
        filterType: mltombfiltertypes.INPUTGROUP
    }
]

export const timeToSeconds = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string") return null;

    const parts = timeStr.split(":");
    if (parts.length !== 3) return null;
  
    const [hh, mm, ss] = parts.map(part => {
      const num = Number(part);
      return isNaN(num) ? null : num;
    });
  
    if (hh === null || mm === null || ss === null) return null;
  
    return hh * 3600 + mm * 60 + ss;
  }